// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider_slider__2q08w","image":"slider_image__1yXio"};